import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@chatterbug/aaron'

const FlashcardsWidgetSkeleton = ({
  headerSection,
  graphSection,
  statsSection,
  footerSection,
  showPlaceholder,
}) => {
  return (
    <Grid
      boxShadow="overlay"
      p={{ _: '2x', tablet: '3x' }}
      borderRadius="1x"
      bg="white100"
      // as per Figma
      gridTemplateColumns={
        showPlaceholder
          ? 'auto'
          : {
              _: '100%',
              tablet: '326px 1fr',
              desktop: '452px 1fr',
            }
      }
    >
      <Box gridColumn="1 / span 2" mb="2x">
        {headerSection}
      </Box>
      <Box
        id="c-level-graph"
        gridColumn={{ _: '1', tablet: '1 / span 1' }}
        gridRow={{ _: '2', tablet: 'auto' }}
        sx={{ position: 'relative' }}
        mr={{ _: 0, tablet: '5x' }}
      >
        {graphSection}
      </Box>
      <Box
        gridColumn={{ _: 1, tablet: '1 / span 2' }}
        gridRow={{ _: '4', tablet: 'auto' }}
        mt="2x"
      >
        {footerSection}
      </Box>
      <Box
        mt={{ _: '4x', tablet: 0 }}
        gridColumn={{ _: '1', tablet: '2 / span 1' }}
        gridRow={{ _: '3', tablet: '2' }}
      >
        {statsSection}
      </Box>
    </Grid>
  )
}

FlashcardsWidgetSkeleton.propTypes = {
  headerSection: PropTypes.any,
  graphSection: PropTypes.any,
  statsSection: PropTypes.any,
  footerSection: PropTypes.any,
  showPlaceholder: PropTypes.bool,
}

export default FlashcardsWidgetSkeleton
